export const NAV_DRAWER_WIDTH = '260px'; // default width for left anchored nav drawer
